import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBucket: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bucket, trash, can"><path d="M4.2467 8.24805L5.75 20.25H18.25L19.7534 8.24805H4.2467Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M2.75 3.75H21.25V8.25H2.75V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
};

export default IconBucket;
